// Shared list-row thumbnail (2026-09-09). The exhibit, zone and exhibition
// list pages each had their own treatment (text tile / map-pin tile /
// picture-icon tile, with or without a broken-image fallback). One component:
// lazy `?variant=thumb` image, "No image" tile when there is no cover, and the
// same tile when the bytes are gone (purged asset / storage drift).
import { useState, type FC } from "react";
import { assetThumbUrl } from "@shared/api/assets";

export interface CoverThumbProps {
  coverImageId: string | null | undefined;
  alt: string;
  /** Tile edge in Tailwind units — 16 (64px) on the exhibit/zone lists, 12 on exhibitions. */
  size?: 12 | 16;
  /** data-testid for the <img>; the tile has no testid (assert on its text). */
  testId?: string;
}

const CoverThumb: FC<CoverThumbProps> = ({
  coverImageId,
  alt,
  size = 16,
  testId,
}) => {
  const [broken, setBroken] = useState(false);
  const showImage = Boolean(coverImageId) && !broken;
  const box = size === 12 ? "w-12 h-12" : "w-16 h-16";
  return (
    <>
      {coverImageId && (
        <img
          loading="lazy"
          src={assetThumbUrl(coverImageId)}
          alt={alt}
          className={`${box} object-cover rounded`}
          style={{ display: showImage ? undefined : "none" }}
          data-testid={testId}
          onError={() => setBroken(true)}
        />
      )}
      <div
        className={`${box} bg-muted rounded items-center justify-center text-xs text-muted-foreground`}
        style={{ display: showImage ? "none" : "flex" }}
      >
        No image
      </div>
    </>
  );
};

export default CoverThumb;
